<script setup lang="ts">
import { computed, inject, useSlots, type ComputedRef } from 'vue'

import useThemeVars from '@lib/composables/useThemeVars'
import useNavigatorDrawer from '@canvas-builder/composables/useNavigatorDrawer'
import type { LaunchDarklyEnv } from '@lib/types/launchDarkly.types'

defineProps<{
  collapsed?: boolean
}>()

const launchDarkly = inject<ComputedRef<LaunchDarklyEnv>>(
  'launchDarkly',
  computed(() => ({})),
)

const slots = useSlots()
const themeVars = useThemeVars()
const { isNavigatorDrawerOpen } = useNavigatorDrawer()

const isExpanded = computed(() => !!slots.drawer && isNavigatorDrawerOpen.value)
</script>

<template>
  <div
    class="navigation-wrapper relative"
    :class="{
      'overflow-x-hidden overflow-y-auto flex-shrink-0 flex-grow-0':
        !!launchDarkly.enable_better_canvas_builder_control_bars_on_zoom,
      'w-[108px]': !!launchDarkly.enable_better_canvas_builder_control_bars_on_zoom && !isExpanded && !collapsed,
      'w-0': collapsed,
    }"
  >
    <div v-show="!collapsed" class="navigation-wrapper__content h-full flex">
      <slot name="drawer" />
      <div class="pb-3 px-8 gap-2 flex flex-col h-full relative">
        <div class="navigation-wrapper__top-section flex flex-col gap-2 items-center">
          <slot name="top" />
        </div>

        <div class="navigation-wrapper__middle-section w-full flex flex-col gap-2 items-center">
          <slot name="middle" />
        </div>

        <div class="navigation-wrapper__bottom-section flex flex-col justify-end gap-2 items-center">
          <slot name="bottom" />
        </div>
      </div>
    </div>
    <slot name="toggle" />
  </div>
</template>

<style lang="scss" scoped>
.navigation-wrapper {
  background-color: v-bind('themeVars.base');

  &__content {
    z-index: 5;
  }

  &__top-section {
    flex: 0 1 100%;
  }

  &__middle-section {
    flex: 0 0 auto;
  }

  &__bottom-section {
    flex: 0 1 100%;
  }
}
</style>
